import { render, staticRenderFns } from "./GoodsBox2.vue?vue&type=template&id=f0bfc7fa&scoped=true&"
import script from "./GoodsBox2.vue?vue&type=script&lang=js&"
export * from "./GoodsBox2.vue?vue&type=script&lang=js&"
import style0 from "./GoodsBox2.vue?vue&type=style&index=0&id=f0bfc7fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bfc7fa",
  null
  
)

export default component.exports